import React from 'react';
// import logger from '../logger';
import '../App.css';

const LoadingIcon = () => {

  return (
    <div className="loading">
        <section className="sec-loading">
            <div className="one"></div>
        </section>
      <h2>Loading Data, Please Wait</h2>
    </div>
  );
};

export default LoadingIcon;